import { token } from '../di';
import { IRouter } from './router.interface';

export const ROUTER = token<IRouter>('Router');
